// ─────────────────────────────────────────────
//  PanelCard — the white card every box in the Timeline's right rail is drawn
//  in: a title, an optional count pill, an optional note, and the content.
//
//  ⚠️ IT LIVES IN ITS OWN FILE SO A CARD CAN BE BUILT WITHOUT THE RAIL. It used
//  to be a local function inside `TimelineSidePanels`, which was fine while that
//  file rendered every card itself. `FinishedRoomsCard` is handed to the rail as
//  a NODE (the page owns its writes), so it has to import the shell — and
//  importing it from `TimelineSidePanels` dragged that module's whole graph
//  along with it, down to `firebase/firestore`. Measured, not guessed: rendering
//  the card on its own in a browser produced an empty page, because the Firebase
//  module initialises at import time and threw before any of it ran.
//
//  A duplicate of this chrome in the new card would have "worked" and been the
//  worse answer — two cards in one rail that stop matching the first time
//  either is touched.
// ─────────────────────────────────────────────
import React from "react";
import tokens from "../../theme/tokens";

const { color, font, radius } = tokens;

export default function PanelCard({ title, count, note, children, testId }) {
  return (
    <section style={s.card} data-testid={testId}>
      <header style={s.cardHead}>
        <h2 style={s.cardTitle}>
          {title}
          {count != null && <span style={s.cardCount}>{count}</span>}
        </h2>
        {note && <span style={s.cardNote}>{note}</span>}
      </header>
      {children}
    </section>
  );
}

const s = {
  card: { background: color.surface.card, border: `1px solid ${color.border.default}`, borderRadius: radius.lg, padding: "11px 13px 13px", minWidth: 0 },
  cardHead: { display: "flex", alignItems: "baseline", justifyContent: "space-between", gap: 10, marginBottom: 9, paddingBottom: 7, borderBottom: `1px solid ${color.border.default}` },
  cardTitle: { fontSize: 11, fontWeight: font.weight.bold, letterSpacing: ".9px", color: color.text.secondary, margin: 0, display: "flex", alignItems: "center", gap: 7 },
  cardCount: { fontSize: 10, fontWeight: font.weight.bold, background: color.surface.raised, color: color.text.secondary, borderRadius: radius.full, padding: "1px 7px", letterSpacing: 0 },
  cardNote: { fontSize: 10.5, color: color.text.muted, letterSpacing: ".3px", whiteSpace: "nowrap" },
};
